import React, { Component, useEffect, useState } from "react";
import { Input, Label, FormGroup } from "reactstrap";

import axios from "axios";
import { API_URL } from "../../constants";


function TaifacareModules(props) {
    
    const [EMR_types, setEMR_types] = useState([])

    const statuses = ["", 'Active', 'Stalled/Inactive', 'Discontinued'];
 
    const getEmrTypes = async() => {
        await axios.get(API_URL+"/emr_types").then(res => setEMR_types( res.data ));
       };

    useEffect(() => {        
        getEmrTypes()  
              
    }, [])

        return (
            
            <div id="EMR_info">
                 <h6  className="green_text_color">Taifacare Information</h6>
                <div id="EMR" className="row  mb-5 form_section shadow-sm bg-white rounded p-4" >

                    <b>Taifacare modules</b>
                    <div className="d-flex justify-content-between">
                        <FormGroup check>
                            <Input id="registration" name="registration" type="checkbox" checked={props.facility_data.registration}
                            className={ props.Original_data && props.Original_data.registration != props.facility_data.registration && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "registration":e.target.checked})}/>                   
                            <Label check>Registration</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="triage" name="triage" type="checkbox" checked={props.facility_data.triage}
                            className={ props.Original_data && props.Original_data.triage != props.facility_data.triage && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "triage":e.target.checked})}/>                   
                            <Label check>Triage</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="consultation" name="consultation" type="checkbox" checked={props.facility_data.consultation}
                                   className={ props.Original_data && props.Original_data.consultation != props.facility_data.consultation && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "consultation":e.target.checked})}/>
                            <Label check>consultation</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="mch" name="mch" type="checkbox" checked={props.facility_data.mch}
                            className={ props.Original_data && props.Original_data.mch != props.facility_data.mch && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "mch":e.target.checked})}/>                   
                            <Label check>MCH</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="admissions" name="admissions" type="checkbox"checked={props.facility_data.admissions} 
                            className={ props.Original_data && props.Original_data.admissions != props.facility_data.admissions && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "admissions":e.target.checked})}/>                   
                            <Label check>Admissions</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="procedures" name="procedures" type="checkbox" checked={props.facility_data.procedures}
                            className={ props.Original_data && props.Original_data.procedures != props.facility_data.procedures && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "procedures":e.target.checked})}/>                   
                            <Label check>Procedures</Label>
                        </FormGroup>

                        <FormGroup check>
                            <Input id="radiology_imaging" name="radiology_imaging" type="checkbox" checked={props.facility_data.radiology_imaging}
                            className={ props.Original_data && props.Original_data.radiology_imaging != props.facility_data.radiology_imaging && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "radiology_imaging":e.target.checked})}/>                   
                            <Label check>Radiology and Imaging</Label>
                        </FormGroup>  
                        <FormGroup check>
                            <Input id="laboratory" name="laboratory" type="checkbox" checked={props.facility_data.laboratory}
                            className={ props.Original_data && props.Original_data.laboratory != props.facility_data.laboratory && "highlight_changed_checkbox"}
                             onChange={(e) => props.setFacility_data({...props.facility_data, "laboratory":e.target.checked})}/>                   
                            <Label check>Laboratory</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="pharmacy" name="pharmacy" type="checkbox" checked={props.facility_data.pharmacy}
                                   className={ props.Original_data && props.Original_data.pharmacy != props.facility_data.pharmacy && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "pharmacy":e.target.checked})}/>
                            <Label check>Pharmacy</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="mortuary" name="mortuary" type="checkbox" checked={props.facility_data.mortuary}
                                   className={ props.Original_data && props.Original_data.mortuary != props.facility_data.mortuary && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "mortuary":e.target.checked})}/>
                            <Label check>Mortuary</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="stock_management" name="stock_management" type="checkbox" checked={props.facility_data.stock_management}
                                   className={ props.Original_data && props.Original_data.stock_management != props.facility_data.stock_management && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "stock_management":e.target.checked})}/>
                            <Label check>Stock Management</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="medical_supplies" name="medical_supplies" type="checkbox" checked={props.facility_data.medical_supplies}
                                   className={ props.Original_data && props.Original_data.medical_supplies != props.facility_data.medical_supplies && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "medical_supplies":e.target.checked})}/>
                            <Label check>Medical Supplies</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="accounting" name="accounting" type="checkbox" checked={props.facility_data.accounting}
                                   className={ props.Original_data && props.Original_data.accounting != props.facility_data.accounting && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "accounting":e.target.checked})}/>
                            <Label check>Accounting</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="dashboards" name="dashboards" type="checkbox" checked={props.facility_data.dashboards}
                                   className={ props.Original_data && props.Original_data.dashboards != props.facility_data.dashboards && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "dashboards":e.target.checked})}/>
                            <Label check>Dashboards</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="reports" name="reports" type="checkbox" checked={props.facility_data.reports}
                                   className={ props.Original_data && props.Original_data.reports != props.facility_data.reports && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "reports":e.target.checked})}/>
                            <Label check>Reports</Label>
                        </FormGroup>

                    </div>
                    <div className="d-flex justify-content-left">
                        <FormGroup check>
                            <Input id="nda_signed" name="nda_signed" type="checkbox" checked={props.facility_data.nda_signed}
                                   className={ props.Original_data && props.Original_data.nda_signed != props.facility_data.nda_signed && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "nda_signed":e.target.checked})}/>
                            <Label check>NDA signed</Label>
                        </FormGroup>
                        <FormGroup check>
                            <Input id="hie_activated" name="hie_activated" type="checkbox" checked={props.facility_data.hie_activated}
                                   className={ props.Original_data && props.Original_data.hie_activated != props.facility_data.hie_activated && "highlight_changed_checkbox"}
                                   onChange={(e) => props.setFacility_data({...props.facility_data, "hie_activated":e.target.checked})}/>
                            <Label check>HIE activated</Label>
                        </FormGroup>
                        </div>
                        <div className="d-flex justify-content-left">
                            <div className="form-group col-md-3 mb-4">
                                <Label for="modules_status">Modules Status:</Label>
                                <Input id="modules_status" name="modules_status" type="select" value={props.facility_data.modules_status} required
                                       className={ props.Original_data && props.Original_data.modules_status != props.facility_data.modules_status && "highlight_changed_data"}
                                       onChange={(e) => props.setFacility_data({...props.facility_data, "modules_status":e.target.value})}>
                                    {
                                        ["", 'Active', 'Stalled/Inactive', 'Discontinued'].map(status => (
                                            <option value={status}>{status}</option>
                                        ))
                                    }
                                </Input>
                            </div>
                    </div>
                </div>
            </div>
        );
    //  }
}

export default TaifacareModules;
